var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import isUrl from 'is-url-superb';
import { format, formatRelative, isSameDay } from 'date-fns';
export var cs = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (a) { return !!a; }).join(' ');
};
export { isUrl };
var groupBlockContent = function (blockMap) {
    var output = [];
    var lastType = undefined;
    var index = -1;
    Object.keys(blockMap).forEach(function (id) {
        var _a, _b;
        var blockValue = (_a = blockMap[id]) === null || _a === void 0 ? void 0 : _a.value;
        if (blockValue) {
            (_b = blockValue.content) === null || _b === void 0 ? void 0 : _b.forEach(function (blockId) {
                var _a, _b;
                var blockType = (_b = (_a = blockMap[blockId]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.type;
                if (blockType && blockType !== lastType) {
                    index++;
                    lastType = blockType;
                    output[index] = [];
                }
                if (index > -1) {
                    output[index].push(blockId);
                }
            });
        }
        lastType = undefined;
    });
    return output;
};
export var getListNumber = function (blockId, blockMap) {
    var groups = groupBlockContent(blockMap);
    var group = groups.find(function (g) { return g.includes(blockId); });
    if (!group) {
        return;
    }
    return group.indexOf(blockId) + 1;
};
export var defaultMapImageUrl = function (url, block) {
    if (!url) {
        return null;
    }
    if (url === null || url === void 0 ? void 0 : url.startsWith('data:')) {
        return url;
    }
    if (url === null || url === void 0 ? void 0 : url.startsWith('/images')) {
        url = "https://www.notion.so".concat(url);
    }
    // You don't need to sign images that are from amazonaws
    if (url.indexOf('amazonaws') != -1 || url.startsWith('attachment')) {
        url = "https://www.notion.so".concat((url === null || url === void 0 ? void 0 : url.startsWith('/image')) ? url : "/image/".concat(encodeURIComponent(url)));
        var notionImageUrlV2 = new URL(url);
        var table = block.parent_table === 'space' ? 'block' : block.parent_table;
        var id = block.id;
        // This is a new edge case that just sprung up on notion. I'm not sure if this is a bug or not so i'm add this as a temporary fix.
        if (table == 'team' && block.type == 'collection_view_page') {
            table = 'collection';
            id = block.collection_id;
        }
        else if (table === 'collection' || table === 'team') {
            table = 'block';
        }
        notionImageUrlV2.searchParams.set('table', table);
        notionImageUrlV2.searchParams.set('id', id);
        notionImageUrlV2.searchParams.set('cache', 'v2');
        url = notionImageUrlV2.toString();
    }
    return url;
};
export var defaultMapPageUrl = function (rootPageId) { return function (pageId) {
    pageId = (pageId || '').replace(/-/g, '');
    if (rootPageId && pageId === rootPageId) {
        return '/';
    }
    else {
        return "/".concat(pageId);
    }
}; };
export var getHashFragmentValue = function (url) {
    return url.includes('#') ? url.replace(/^.+(#.+)$/, '$1') : '';
};
var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
export var formatDate = function (input) {
    var date = new Date(input);
    var month = date.getMonth();
    return "".concat(months[month], " ").concat(date.getUTCDate(), ", ").concat(date.getUTCFullYear());
};
export var formatRangeDateTime = function (data) {
    var start_date = data.start_date, start_time = data.start_time, end_date = data.end_date, end_time = data.end_time;
    var start = new Date(start_date + ' ' + start_time);
    var end = new Date(end_date + ' ' + end_time);
    var timeInfo = formatRelative(start, new Date()) + ' - ' + formatRelative(end, new Date());
    if (isSameDay(start, end)) {
        timeInfo = formatRelative(start, new Date()) + ' - ' + format(end, 'h:mm a');
        // Currently date-fns turn the realtive format into mm/dd/yyy
        //  if the time is far away
        if (timeInfo.includes('/')) {
            var formattedStarttime = format(start, 'MMMM dd, yyyy');
            timeInfo = formattedStarttime + ' - ' + format(end, 'h:mm a');
            // if no time info
            if (!formattedStarttime.includes(':')) {
                timeInfo =
                    formattedStarttime +
                        ' ' +
                        format(start, 'h:mm a') +
                        ' - ' +
                        format(end, 'h:mm a');
            }
        }
    }
    return timeInfo;
};
export var isBrowser = typeof window !== 'undefined';
export function getCollectionGroups(collection, collectionView, collectionData) {
    var _a;
    var rest = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        rest[_i - 3] = arguments[_i];
    }
    var elems = ((_a = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _a === void 0 ? void 0 : _a.collection_groups) || [];
    return elems === null || elems === void 0 ? void 0 : elems.map(function (_a) {
        var _b, _c;
        var property = _a.property, hidden = _a.hidden, _d = _a.value, value = _d.value, type = _d.type;
        var isUncategorizedValue = typeof value === 'undefined';
        var isDateValue = value === null || value === void 0 ? void 0 : value.range;
        // TODO: review dates reducers
        var queryLabel = isUncategorizedValue
            ? 'uncategorized'
            : isDateValue
                ? ((_b = value.range) === null || _b === void 0 ? void 0 : _b.start_date) || ((_c = value.range) === null || _c === void 0 ? void 0 : _c.end_date)
                : (value === null || value === void 0 ? void 0 : value.value) || value;
        var prop = "results:".concat(type, ":").concat(queryLabel);
        var collectionGroup = collectionData[prop];
        var queryValue = !isUncategorizedValue && (isDateValue || (value === null || value === void 0 ? void 0 : value.value) || value);
        var schema = collection.schema[property];
        // Checkbox boolen value must be Yes||No
        if (type === 'checkbox' && value) {
            queryValue = 'Yes';
        }
        if (isDateValue) {
            schema = {
                type: 'text',
                name: 'text'
            };
            // TODO: review dates format based on value.type ('week'|'month'|'year')
            if (value.type === 'week') {
                queryValue = format(new Date(queryLabel), 'MMM d, YYY');
            }
            else if (value.type === 'month') {
                queryValue = format(new Date(queryLabel), 'MMM YYY');
            }
            else if (value.type === 'year') {
                queryValue = format(new Date(queryLabel), 'YYY');
            }
            else {
                queryValue = format(new Date(queryLabel), 'MMM d, YYY hh:mm aa');
            }
            // queryValue = format(new Date(queryLabel), 'MMM d, YYY hh:mm aa')
        }
        return __assign({ collectionGroup: collectionGroup, schema: schema, value: queryValue || 'No description', hidden: hidden, collection: collection, collectionView: collectionView, collectionData: collectionData, blockIds: collectionGroup === null || collectionGroup === void 0 ? void 0 : collectionGroup.blockIds, prop: prop }, rest);
    });
}
export function generateAggregate(type, key, pages, blocks) {
    try {
        type = type.toLowerCase();
        var aggregate = 0;
        var rows = getKeyValues(key, pages, blocks);
        if (type === 'sum') {
            aggregate = 0;
            aggregate = rows.reduce(function (acc, row) { return (acc += Number(row)); }, 0);
        }
        else if (type === 'count') {
            aggregate = rows.length;
        }
        else if (type === 'count_values') {
            aggregate = rows.filter(function (row) { return row !== ''; }).length;
        }
        else if (type === 'unique') {
            aggregate = Array.from(new Set(rows)).length;
        }
        else if (type === 'empty') {
            aggregate = rows.filter(function (row) { return row === ''; }).length;
        }
        else if (type === 'not_empty') {
            aggregate = rows.filter(function (row) { return row !== ''; }).length;
        }
        else if (type === 'percent_empty') {
            aggregate =
                (rows.filter(function (row) { return row === ''; }).length / rows.length) * 100 + '%';
        }
        else if (type === 'percent_not_empty') {
            aggregate =
                (rows.filter(function (row) { return row !== ''; }).length / rows.length) * 100 + '%';
        }
        else if (type === 'average') {
            aggregate =
                rows.reduce(function (acc, row) { return (acc += Number(row)); }, 0) / rows.length;
        }
        else if (type === 'median') {
            var sorted = rows.sort(function (a, b) { return a - b; });
            var middle = Math.floor(sorted.length / 2);
            aggregate =
                sorted.length % 2 === 0
                    ? (Number(sorted[middle]) + Number(sorted[middle - 1] || 0)) / 2
                    : sorted[middle];
        }
        else if (type === 'min') {
            aggregate = Math.min.apply(Math, rows);
        }
        else if (type === 'max') {
            aggregate = Math.max.apply(Math, rows);
        }
        else if (type === 'range') {
            aggregate = Math.max.apply(Math, rows) - Math.min.apply(Math, rows);
        }
        return aggregate;
    }
    catch (error) {
        return null;
    }
}
function getKeyValues(key, pages, blocks) {
    var _a, _b, _c, _d;
    var rows = [];
    for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
        var page = pages_1[_i];
        var block = blocks === null || blocks === void 0 ? void 0 : blocks[page];
        if (block) {
            var value = block.value;
            var properties = value.properties;
            rows.push(((_d = (_c = (_b = (_a = properties === null || properties === void 0 ? void 0 : properties[key]) === null || _a === void 0 ? void 0 : _a.flat()) === null || _b === void 0 ? void 0 : _b.flat()) === null || _c === void 0 ? void 0 : _c.flat()) === null || _d === void 0 ? void 0 : _d[0]) || '');
        }
    }
    return rows;
}
export function generateFilter(_a) {
    var property = _a.property, operator = _a.operator, type = _a.type, value = _a.value;
    return {
        property: property,
        filter: {
            operator: operator,
            value: { type: type, value: value }
        }
    };
}
export function signFile(url, blockId) {
    return url.indexOf('www.notion.so') == -1
        ? "https://www.notion.so/signed/".concat(encodeURIComponent(url), "?table=block&id=").concat(blockId, "&cache=v2")
        : url;
}
export function retrieveBlocks(collection, collectionView, collectionData, recordMap) {
    var _a, _b;
    // find the result group.
    var blockIds = Object.keys(collectionData || {})
        .filter(function (key) { return 'results' == collectionData[key].type; })
        .map(function (key) { return collectionData[key].blockIds; })
        .find(function (ids) { return ids.length > 0 && ids.every(function (id) { return typeof id == 'string'; }); }) || [];
    var filters = (((_a = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _a === void 0 ? void 0 : _a.property_filters) || [])
        .map(function (f) { return f.filter; })
        .filter(function (f) { var _a, _b; return !!((_b = (_a = f === null || f === void 0 ? void 0 : f.filter) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.value); });
    /*
      I'm adding thie collectionView query2 a temporary fix for some collection whose filtering was properly handle.
      My reasoning is that collection views with query2 usually provide what we expect them to provide but i'm going to investigate further.
    */
    if (blockIds.length > 0 && filters.length === 0 && !(collectionView === null || collectionView === void 0 ? void 0 : collectionView.query2)) {
        var properties = ((_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.gallery_properties) || {};
        var requiredProperties_1 = Object.entries(properties)
            .filter(function (_a) {
            var value = _a[1];
            return value.visible;
        })
            .map(function (v) { var _a, _b; return ((_b = (_a = v.flat()) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.property) || ''; })
            .filter(function (p) { return !!p; });
        var altBlockIds = Object.entries(recordMap.block)
            .map(function (b) { var _a; return (_a = b[1]) === null || _a === void 0 ? void 0 : _a.value; })
            .filter(function (b) { return (b === null || b === void 0 ? void 0 : b.parent_id) == collection.id; })
            .map(function (b) { return b.id; });
        blockIds = blockIds.length > altBlockIds.length ? blockIds : altBlockIds;
        var sortedBlocks = [];
        var pageSort = collectionView.page_sort || [];
        for (var _i = 0, pageSort_1 = pageSort; _i < pageSort_1.length; _i++) {
            var blockId = pageSort_1[_i];
            if (blockIds.includes(blockId))
                sortedBlocks.push(blockId);
        }
        // not all blocks come with the page sort. Includes those at the end.
        for (var _c = 0, blockIds_1 = blockIds; _c < blockIds_1.length; _c++) {
            var blockId = blockIds_1[_c];
            if (!sortedBlocks.includes(blockId))
                sortedBlocks.push(blockId);
        }
        blockIds = sortedBlocks;
        if (requiredProperties_1.length == 0) {
            /**
             * :TODO - Test this for all collections
             * Remove blocks that don't have any properties
             * This is a temporary fix for some collections
             * that don't have any properties.
             * I'm aware that this might cause some issues
             * but this should keep [https://actually-tumble-b04.notion.site/Gerar-Revilla-271f94c094144ffcbef280b7892ccfca] happy for now.
             */
            blockIds = blockIds.filter(function (id) {
                var _a;
                var block = (_a = recordMap.block[id]) === null || _a === void 0 ? void 0 : _a.value;
                var properties = (block === null || block === void 0 ? void 0 : block.properties) || {};
                return Object.keys(properties).length > 0;
            });
        }
        else {
            // remove blocks that don't have the required properties
            if (!('7d13eb7d-5c52-4899-a074-8e907e90e3f2' in recordMap.block ||
                '4639305e-dafc-48db-90da-a58af3d064b5' in recordMap.block)) {
                blockIds = sortedBlocks.filter(function (id) {
                    var _a;
                    var block = (_a = recordMap.block[id]) === null || _a === void 0 ? void 0 : _a.value;
                    var properties = (block === null || block === void 0 ? void 0 : block.properties) || {};
                    return requiredProperties_1.every(function (p) { return !!properties[p]; });
                });
            }
        }
    }
    return blockIds;
}
export function isSubArray(array, sub) {
    // console.log({array, sub})
    array = array.sort(function (a, b) { return a - b; });
    sub = sub.sort(function (a, b) { return a - b; });
    var t = 0;
    for (var _i = 0, sub_1 = sub; _i < sub_1.length; _i++) {
        var s = sub_1[_i];
        if (array.includes(s))
            ++t;
    }
    return t > 0;
}
//# sourceMappingURL=utils.js.map